import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { translations } from '@utils/translations';
import styles from '../../../styles/components/searchInput.module.scss';
import SearchField from './SearchField';
import SearchSelect from './SearchSelect';
import { setFilter } from '../store/actions';

const SearchForm = ({ fieldData }) => {
    const dispatch = useDispatch();
    const appSettings = useSelector(({ rootReducer }) => rootReducer.baseSettings);
    const lang = appSettings.searchLanguage ? appSettings.searchLanguage : "en";
    const translate = (s) => translations[lang][s] || s;
    const onSubmit = (e) => {
        // Search field will always be the first entry
        if (e.target[0].value) {
            dispatch(setFilter(`search=${e.target[0].value}`));
        }
    };

    // Remove any HTML Entry that starts with & and ends with ; and replace it with &
    // e.g. &Amp; or &#038;
    function removeHtmlEntries(str) {
        return str.replace(/&.+;/g, "&");
    }

    return (
        <form className={styles.field}
              onSubmit={(e) => {
                  e.preventDefault();

                  onSubmit(e);
              }}
        >
            {fieldData.map((entry) => {
                switch (entry.type) {
                    case 'search':
                        return <SearchField params={entry} />;
                    case 'checkboxes':
                    case 'fselect': {
                        const selectedRename = [];
                        entry.choices?.forEach((el) => {
                            el.label = removeHtmlEntries(el.label);
                            entry.selected.includes(el.value) && selectedRename.push({
                                label: el.label,
                                value: el.value,
                            });
                        });

                        return <SearchSelect
                            key={`job-search-${entry.name}-select`}
                            content={entry.choices}
                            title={translate(`search_${entry.name}`)}
                            className={clsx(styles.container, styles.input, styles.searchFacet)}
                            data-testid={`${entry.name}Input`}
                            type="text"
                            placeholder={translate(`search_${entry.name}_placeholder`)}
                            selected={selectedRename}
                            parentValue={entry.name}
                        />;
                    }
                    default:
                        return null;
                }
            })}
        </form>
    );
};

export default SearchForm;
